<template>
  <div v-if="screenprotectortypes">
    <app-header :title="(originalName) ? 'Edit '+ originalName: 'New Screen Protector Type'" subtitle="Screen Protector Type">
      <b-button variant="primary" @click="save()">
        Save Changes
      </b-button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="4">
          <b-form name="editorForm">
            <!--Name-->
            <b-form-group>
              <label>Name</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="screenprotectortypes.name"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <!--Description-->
            <b-form-group>
              <label>Description</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="screenprotectortypes.description"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <!--Icon-->
            <b-form-group>
              <label>Icon</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="screenprotectortypes.icon"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="8"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import CancelButton from '@/components/CancelButton';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      screenprotectortypes: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      if (this.$route.query.id) {
        $api.get(`/v1/internal/screenprotectortypes/${this.$route.query.id}`).then((screenprotectortypes) => {
          this.originalName = screenprotectortypes.name;
          this.screenprotectortypes = screenprotectortypes;
        });
      } else {
        this.screenprotectortypes = {};
      }
    },

    save() {
      if (this.screenprotectortypes.id) {
        $api.put(`/v1/internal/screenprotectortypes/${this.screenprotectortypes.id}`, this.screenprotectortypes).then((screenprotectortypes) => {
          this.$router.push({
            name: 'screenprotectortype-detail',
            params: screenprotectortypes,
          });
        });
      } else {
        $api.post('/v1/internal/screenprotectortypes', this.screenprotectortypes).then((screenprotectortypes) => {
          this.$router.push({
            name: 'screenprotectortype-detail',
            params: screenprotectortypes,
          });
        });
      }
    },
  },
};
</script>
